import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "buttons" }

import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';
import TeamPropertiesForm from '@/components/service_teams/forms/TeamPropertisForm.vue';
import { VueFinalModal } from 'vue-final-modal';
import TileCard from '@/components/util/TileCard.vue';
import { useSettingsStore } from '@/stores/setting';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditTeamPropertiesModal',
  props: {
    team: { Type: {} as ServiceTeamItem, required: true, default: () => ({} as ServiceTeamItem) },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const settingsStore = useSettingsStore();
const props = __props;

const emit = __emit;

function updateService() {
    props.team.service = settingsStore.getServices.filter((svc) => svc.id === props.team.service.id)[0];
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "modal",
    "content-class": "modal-content",
    "overlay-transition": "vfm-fade",
    clickToClose: false,
    onClickOutside: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(TileCard, {
        loaded: _unref(settingsStore).getServicesLoaded,
        class: "tile-card"
      }, {
        body: _withCtx(() => [
          _createVNode(TeamPropertiesForm, {
            team: props.team
          }, null, 8, ["team"])
        ]),
        _: 1
      }, 8, ["loaded"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "accent",
          onClick: _cache[0] || (_cache[0] = () => emit('close')),
          x: ""
        }, "Accept")
      ])
    ]),
    _: 1
  }))
}
}

})